import React from 'react';
import ReactDOM from 'react-dom/client';
// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
// Bootstrap Bundle JS
import "bootstrap/dist/js/bootstrap.bundle.min";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {CollapseContextProvider} from './store/sidebar-context';
import ThemeProvider from 'react-bootstrap/ThemeProvider'
import {Provider} from 'react-redux';
import store from './store/index';

import { ApiProvider } from '@reduxjs/toolkit/dist/query/react';
import { apiSlice } from './api/apiSlice';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools'

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
  <React.StrictMode>
  <ThemeProvider
  breakpoints={['xxxl', 'xxl', 'xl', 'lg', 'md', 'sm', 'xs', 'xxs']}
  minBreakpoint="xxs"

><Provider store={store}>
{/* <ApiProvider api={apiSlice}> */}
<QueryClientProvider client={queryClient}>
  <App />
  <ReactQueryDevtools initialIsOpen />
  </QueryClientProvider>
  </Provider>
  {/* </ApiProvider> */}
    
    </ThemeProvider>
 </React.StrictMode>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
